import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareGridCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareGridCircle"><Path d="M3.5 3.5H10.5V10.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M3.5 13.5H10.5V20.5H3.5V13.5Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 17C13.5 15.067 15.067 13.5 17 13.5C18.933 13.5 20.5 15.067 20.5 17C20.5 18.933 18.933 20.5 17 20.5C15.067 20.5 13.5 18.933 13.5 17Z" stroke="currentColor" strokeLinecap="round"/><Path d="M13.5 3.5H20.5V10.5H13.5V3.5Z" stroke="currentColor" strokeLinecap="round"/></CentralIconBase>;
});

export default IconSquareGridCircle;
